/*
 *
 * MsTeamsVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_MSTEAMS } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const msTeamsVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_MSTEAMS.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_MSTEAMS.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_MSTEAMS.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default msTeamsVerifyReducer;
